import { z } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

export const yourDetailsSchema = toFormikValidationSchema(
    z.object({
        firstName: z.string("MyProfile.MyDetails.Error_FirstName_Required"),
        lastName: z.string("MyProfile.MyDetails.Error_LastName_Required"),
        email: z.email("MyProfile.MyDetails.Error_Email_Invalid").min(1, "MyProfile.MyDetails.Error_Email_Required"),
        phoneNumber: z
            .string()
            .regex(/^(?:[0-9] ?){3,14}[0-9]$/g, "YourProfile.YourDetails.Error_PhoneNumber_Invalid")
            .optional(),
    }),
);

export const getChangePasswordSchema = (currentPassword: boolean) => {
    const newPassword = z
        .string("MyProfile.ChangePassword.Error_NewPassword_Required")
        .min(6, "MyProfile.ChangePassword.Error_NewPassword_6_Characters");
    const repeatNewPassword = z.string("MyProfile.ChangePassword.Error_RepeatNewPassword_Required").nullable();

    if (currentPassword) {
        return toFormikValidationSchema(
            z
                .object({
                    currentPassword: z.string("MyProfile.ChangePassword.Error_CurrentPassword_Required"),
                    newPassword,
                    repeatNewPassword,
                })
                .refine((data) => data.repeatNewPassword === null || data.repeatNewPassword === data.newPassword, {
                    message: "MyProfile.ChangePassword.Error_RepeatNewPassword_DoesntMatch",
                    path: ["repeatNewPassword"],
                }),
        );
    }
    return toFormikValidationSchema(
        z
            .object({
                newPassword,
                repeatNewPassword,
            })
            .refine((data) => data.repeatNewPassword === null || data.repeatNewPassword === data.newPassword, {
                message: "MyProfile.ChangePassword.Error_RepeatNewPassword_DoesntMatch",
                path: ["repeatNewPassword"],
            }),
    );
};
